export default "__VITE_ASSET__a9ea5f44__"